/*eslint-disable*/
import React, {useEffect,useState} from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// @material-ui/icons
import { LocalBar, House,Dashboard, Person, Home, LocalActivity, PartyMode, LocalAtm } from "@material-ui/icons";

// core components
import Button from "componentsHomePage/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const [role,setrole] = useState("")
  useEffect(() => {
    if(localStorage.getItem("user")){
  setrole(JSON.parse(localStorage.getItem("user")).role)
  }
  }, []);

  const classes = useStyles();
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
      <Link to="/bars" className="text-white">
        <Button color="transparent" className={classes.navLink} >
          <LocalBar className={classes.icons} /> Bars and Clubs
        </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
      <a href="https://www.airbnb.com/p/highclassproperties" target="_blank" className="text-white">
        <Button color="transparent" className={classes.navLink} >
          <Home className={classes.icons} /> Rentals
        </Button>
      </a>
      </ListItem>
      <ListItem className={classes.listItem}>
      <Link to="/venue" className="text-white">
        <Button color="transparent" className={classes.navLink} >
          <LocalAtm className={classes.icons} /> Venue Hire
        </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
      <Link to="/job" className="text-white">
        <Button color="transparent" className={classes.navLink} >
          <Person className={classes.icons} /> Jobs
        </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to={localStorage.getItem("user") ? '/' + JSON.parse(localStorage.getItem("user")).role + '/index' : '/auth'} className="text-white" >
          <Button color="transparent" className={classes.navLink} >
            <Dashboard/> {localStorage.getItem("user") ? "Dashboard" : "Log In"}
          </Button>
        </Link>
      </ListItem>
    </List>
    
  );
}
